module.exports = __webpack_public_path__ + "img/GIFT_CARD_Physical.9f94692.png";